'use client';
import { useEffect, useState } from 'react';
import SideNavItem from '../SideNavItem/SideNavItem';
import { icons } from '@/Icons';

const LiveSupport = () => {
	const [isSalesIQReady, setIsSalesIQReady] = useState(false);

	// Check if Zoho SalesIQ is loaded and ready
	useEffect(() => {
		if (typeof window !== 'undefined') {
			window.$zoho = window.$zoho || {};
			window.$zoho.salesiq = window.$zoho.salesiq || {};
			window.$zoho.salesiq.ready = function () {
				setIsSalesIQReady(true);
			};
		}
	}, []);

	const openChat = () => {
		if (
			!isSalesIQReady ||
			typeof window.$zoho?.salesiq?.floatwindow?.visible === 'undefined'
		) {
			console.error('SalesIQ is not ready yet.');
			return;
		}

		window.$zoho.salesiq.floatwindow.visible('show');
	};

	return (
		<SideNavItem
			title={'Live Support'}
			onClick={() => {
				openChat();
			}}
			icon={<icons.livesupport />}
		/>
	);
};

export default LiveSupport;
